import { useMutation } from 'react-query';
import { wgApi } from '../../../app/src/features/api/wgApi';

interface PostPartyOfferParams {
  partyId: string;
  payload: {
    start_date: string;
    quote_id: string;
    language: string;
    signature_redirect_url: string;
    generate_sepa_document?: boolean;
  };
}

interface Response {
  id: string;
  ref: string;
  revision: number;
  exports_queued: {
    insurance_module_export: boolean;
    crm_export: boolean;
  };
}

export const postPartyOffer = async ({
  partyId,
  payload,
}: PostPartyOfferParams) => {
  const path = `v1/api/parties/${partyId}/offers`;
  const { data, isError } = await wgApi.post<Response>(path, payload);
  if (isError) throw new Error();
  return data;
};

export const usePostPartyOffer = () => {
  return useMutation(postPartyOffer, {
    onMutate: () => {
      // optimistic update GET documents call
    },
  });
};
